//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import LocaleSwitcher from "@/components/LocaleSwitcher";
import AuthService from "@/services/AuthService";
import { mapState } from "vuex";

export default {
  name: "Menu",
  props: ["leftDrawerOpen", "title"],

  // components: { LocaleSwitcher },
  data() {
    return {
      darkMode: false,
      auth: null,
    };
  },
  created: function() {
    this.initAuthService();
  },

  computed: {
    ...mapState("main", ["user", "appVersion"]),
  },
  methods: {
    async initAuthService() {
      this.auth = await AuthService.create();
    },

    login() {
      this.auth.login();
    },
    logout() {
      this.auth.logout();
    },
    silentRenew() {
      this.auth.silentRenew();
    },
    async getUser() {
      await this.auth.getUser();
    },
    async getToken() {
      await this.auth.getAccessToken();
    },
    toggleDarkMode() {
      this.$q.dark.set(this.darkMode);
    },
    ToggleLeftDrawerOpen() {
      this.$emit("ToggleLeftDrawerOpen");
    },
  },
};
